import { FeatureFlagKey } from '../../types/FeatureFlag';
import { AppState } from '../../store/types/Store';

export const selectApplicationCardEnabled = (state: AppState): boolean =>
  Boolean(
    state.feature.userConfigFeatures[FeatureFlagKey.DMB_APPLICATION_CARD]?.value,
  );
